import _ from "underscore";
import ModuleListConfiguration from "./ModuleListConfiguration";
import QuickSearchFields from "../../components/Records/QuickSearchFields";

interface Props {
  currentModule: any;
}

const DataSourceSettings = ({ currentModule }: Props) => {
  return (
    <>
      <QuickSearchFields currentModule={currentModule} />
      <ModuleListConfiguration currentModule={currentModule} />
    </>
  );
};

export default DataSourceSettings;
